import React, { useEffect, useState } from 'react';

import { Alert, Box, Button, Card, CardContent, Chip, CircularProgress, Grid, Typography } from '@mui/material';

import { IconArrowLeft, IconBolt, IconCode, IconEdit, IconWorld } from '@tabler/icons';

import { useHistory, useParams } from 'react-router-dom';

import axios from 'axios';

const hostname = window.location.hostname;
let AGENT_SERVER;

// if (hostname.startsWith('crm.')) {
//     AGENT_SERVER = 'https://apichat.loged.com.br';
// } else {
//     AGENT_SERVER = 'http://127.0.0.1:7000';
// }
if (hostname.startsWith('crm.')) {
    AGENT_SERVER = 'https://apichat.loged.com.br';
} else if (hostname.startsWith('glazzbeauty.')) {
    AGENT_SERVER = 'https://apichat.loged.com.br';
} else if (hostname.startsWith('casamathiola.')) {
    AGENT_SERVER = 'https://apichat.loged.com.br';
} else if (hostname.startsWith('bliveinpets.')) {
    AGENT_SERVER = 'https://apichat.loged.com.br';
} else if (hostname.startsWith('acin.')) {
    AGENT_SERVER = 'https://apichat.loged.com.br';
} else if (hostname.startsWith('braza55.')) {
    AGENT_SERVER = 'https://apichat.loged.com.br';
} else if (hostname.startsWith('po.')) {
    AGENT_SERVER = 'https://apichat.loged.com.br';
} else if (hostname.startsWith('florestavet.')) {
    AGENT_SERVER = 'https://apichat.loged.com.br';
} else if (hostname.startsWith('quimicer.')) {
    AGENT_SERVER = 'https://apichat.loged.com.br';
} else if (hostname.startsWith('imobiliaria.')) {
    AGENT_SERVER = 'https://apichat.loged.com.br';
} else {
    AGENT_SERVER = 'http://127.0.0.1:7000';
}
// const AGENT_SERVER = process.env.REACT_APP_AGENT_SERVER || 'http://127.0.0.1:7000';
// const AGENT_SERVER = process.env.REACT_APP_AGENT_SERVER || 'https://apichat.loged.com.br';

const agentApi = axios.create({
    baseURL: AGENT_SERVER
});

agentApi.interceptors.request.use((config) => {
    const token = localStorage.getItem('access_token');

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
});

const DetailActionTools = () => {
    // const { id } = useParams();
    const { toolId } = useParams();

    const history = useHistory();

    const [actions, setActions] = useState([]);

    const [loading, setLoading] = useState(true);

    const [status, setStatus] = useState({
        type: '',
        message: ''
    });

    console.log(`toolId: ${toolId}`);

    useEffect(() => {
        carregarActions();
    }, []);

    const carregarActions = async () => {
        try {
            const response = await agentApi.get(`/agent/api/v1/aitools/${toolId}/action/`);

            const data = response.data?.actions || [];

            data.sort((a, b) => a.order - b.order);

            setActions(data);
        } catch (error) {
            console.error(error);

            setStatus({
                type: 'error',
                message: 'Erro ao carregar actions.'
            });
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    py: 10
                }}
            >
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Box>
            {/* HEADER */}

            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 4
                }}
            >
                <Box>
                    <Button
                        startIcon={<IconArrowLeft size={18} />}
                        onClick={() => history.goBack()}
                        sx={{
                            mb: 2,
                            textTransform: 'none'
                        }}
                    >
                        Voltar
                    </Button>

                    <Typography
                        variant="h2"
                        sx={{
                            fontWeight: 800
                        }}
                    >
                        Ações da ferramenta
                    </Typography>

                    <Typography
                        variant="body2"
                        sx={{
                            color: 'text.secondary'
                        }}
                    >
                        Fluxo de execução da tool
                    </Typography>
                </Box>
            </Box>

            {status.message && <Alert severity={status.type}>{status.message}</Alert>}

            <Grid container spacing={3}>
                {actions.map((action) => (
                    <Grid item xs={12} key={action.id}>
                        <Card
                            sx={{
                                borderRadius: '18px',
                                border: '1px solid #e2e8f0',
                                boxShadow: '0 4px 20px rgba(0,0,0,0.05)'
                            }}
                        >
                            <CardContent>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        mb: 2
                                    }}
                                >
                                    <Box>
                                        <Typography
                                            variant="h4"
                                            sx={{
                                                fontWeight: 800
                                            }}
                                        >
                                            {action.name}
                                        </Typography>

                                        <Box
                                            sx={{
                                                display: 'flex',
                                                gap: 1,
                                                mt: 1
                                            }}
                                        >
                                            <Chip
                                                icon={<IconBolt size={14} />}
                                                label={`Ordem ${action.order}`}
                                                color="primary"
                                                variant="outlined"
                                            />

                                            <Chip icon={<IconWorld size={14} />} label={action.config?.method} variant="outlined" />
                                        </Box>
                                    </Box>

                                    <Button
                                        variant="outlined"
                                        startIcon={<IconEdit size={16} />}
                                        sx={{
                                            textTransform: 'none'
                                        }}
                                    >
                                        Editar
                                    </Button>
                                </Box>

                                <Typography
                                    variant="subtitle2"
                                    sx={{
                                        fontWeight: 700,
                                        mb: 1
                                    }}
                                >
                                    URL
                                </Typography>

                                <Box
                                    sx={{
                                        background: '#f8fafc',
                                        border: '1px solid #e2e8f0',
                                        borderRadius: '12px',
                                        p: 2,
                                        mb: 3,
                                        fontFamily: 'monospace'
                                    }}
                                >
                                    {action.config?.url}
                                </Box>

                                <Typography
                                    variant="subtitle2"
                                    sx={{
                                        fontWeight: 700,
                                        mb: 1
                                    }}
                                >
                                    Configuração
                                </Typography>

                                <Box
                                    sx={{
                                        background: '#0f172a',
                                        color: '#fff',
                                        borderRadius: '16px',
                                        p: 2,
                                        overflowX: 'auto',
                                        fontFamily: 'monospace',
                                        fontSize: '0.85rem'
                                    }}
                                >
                                    <pre
                                        style={{
                                            margin: 0
                                        }}
                                    >
                                        {JSON.stringify(action.config, null, 2)}
                                    </pre>
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default DetailActionTools;
